import React from 'react';

import { MenuItemsContextType } from './types';

export const MenuItemsContext = React.createContext<MenuItemsContextType>({} as MenuItemsContextType);
